// components/error/NotFoundPage.jsx — tam 404 səhifəsi (Header + xəta kartı + Footer).
// App.jsx-də catch-all route (`path='*'`) üçün istifadə olunur.
import React from 'react'
import { Helmet } from 'react-helmet-async'
import Headers from '../Headers'
import Footer from '../Footer'
import ErrorPage from './ErrorPage'

const NotFoundPage = ({ code = 404 }) => (
    <div className='min-h-screen bg-slate-50'>
        <Helmet><title>Səhifə tapılmadı - ItemZo</title><meta name='robots' content='noindex' /></Helmet>
        <Headers />
        <ErrorPage code={code} />
        <Footer />
    </div>
)

export default NotFoundPage
